import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectPage, selectSidebarSelected } from "../../redux/sidebarSlice";
import { selectColorsSchema } from "../../redux/main/uiSlice";
import { useTheme } from "../ThemeProvider";

export default function SubMenuField({ module }) {
    const selected = useSelector(selectSidebarSelected);
    const colorsSchema = useSelector(selectColorsSchema);
    
    // Gestiamo il caso in cui ThemeProvider non sia disponibile
    let theme;
    try {
        theme = useTheme();
    } catch (e) {
        // Creiamo un tema di fallback usando colorsSchema
        theme = {
            primary: colorsSchema ? colorsSchema[1] : '#3b82f6',
            secondary: colorsSchema ? colorsSchema[2] : '#60a5fa',
            text: { primary: '#1e293b' }
        };
        console.warn('SubMenuField: ThemeProvider non trovato, utilizzo colori di fallback');
    }
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleFieldClick = () => {
        dispatch(selectPage(module.id));
        navigate(`/${module.id}`);
    }
    return (
        /* Field */
        <li
            onClick={handleFieldClick}
            style={{
                backgroundColor: selected === module.id ? 
                    `${theme?.secondary || (colorsSchema ? colorsSchema[2] : '#60a5fa')}20` : 'transparent',
                transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
                const secondaryColor = theme?.secondary || (colorsSchema ? colorsSchema[2] : '#60a5fa');
                e.currentTarget.style.backgroundColor = `${secondaryColor}15`;
                e.currentTarget.style.paddingLeft = '18px'; // Effetto di scorrimento leggero
            }}
            onMouseLeave={(e) => {
                const secondaryColor = theme?.secondary || (colorsSchema ? colorsSchema[2] : '#60a5fa');
                e.currentTarget.style.backgroundColor = selected === module.id ? 
                    `${secondaryColor}20` : 'transparent';
                e.currentTarget.style.paddingLeft = '16px';
            }}
            className={`w-full py-2 px-4 rounded-lg cursor-pointer flex items-center h-[36px] text-sm leading-4 group pl-8`}
        >
            {/* Rimosso il punto/pallino come richiesto */}
            <div style={{ 
                color: selected === module.id ? 
                    (theme?.primary || (colorsSchema ? colorsSchema[1] : '#3b82f6')) : 
                    (theme?.text?.primary || '#1e293b'),
                fontWeight: selected === module.id ? '500' : '400',
                transition: 'color 0.2s ease, font-weight 0.2s ease',
                borderLeft: selected === module.id ? 
                    `2px solid ${theme?.primary || (colorsSchema ? colorsSchema[1] : '#3b82f6')}` : 
                    'none',
                paddingLeft: selected === module.id ? '8px' : '0'
            }}>
                {module.menuLabel[0].label}
            </div>
        </li>
    )
}